export const asError = (thrown: unknown): Error => {
  if (thrown instanceof Error) {
    if ('shortMessage' in thrown) return new Error(thrown.shortMessage as string)

    return thrown
  }

  let message: string

  if (typeof thrown === 'string') {
    message = thrown
  } else {
    try {
      message = JSON.stringify(thrown)
    } catch {
      message = String(thrown)
    }
  }

  return new Error(message)
}
